import { render, staticRenderFns } from "./ManejoCreditosOtorgados.vue?vue&type=template&id=0ae5653a"
import script from "./ManejoCreditosOtorgados.vue?vue&type=script&lang=js"
export * from "./ManejoCreditosOtorgados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports